import { useMutation } from '@tanstack/react-query';
import { getAudioCreditsEstimation } from '../../services';

export function useAudioCreditsEstimation() {
  return useMutation(getAudioCreditsEstimation, { onSuccess: (data) => data });
}
